module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "matching-tags"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    attrs: {
      "src": 'http://node-runner.p.owal.io:9612/faceimage/' + _vm.$route.params.runtime_face_uuid
    }
  }), _vm._v("\n    Matching Tags for runtime_face_uuid=" + _vm._s(_vm.$route.params.runtime_face_uuid)), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "matches-area"
  }, _vm._l((_vm.matching_tags), function(tag) {
    return _c('div', {
      key: tag.runtime_face_uuid,
      staticClass: "match-row"
    }, [_c('div', {
      staticClass: "image-area"
    }, [_c('img', {
      attrs: {
        "src": 'http://node-runner.p.owal.io:9612/faceimage/' + tag.runtime_face_uuid
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": _vm.imageUriForFrontendFaceUUID(tag.frontend_face_uuid)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-area"
    }, [_vm._v("\n        " + _vm._s(_vm.diffformat(tag.diff)) + " diff with " + _vm._s(_vm.personNameForUUID(tag.frontend_face_uuid)) + "\n      ")])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41c62d74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MatchingTags.vue
// module id = 303
// module chunks = 1